import { render, staticRenderFns } from "./VideoEdit.vue?vue&type=template&id=37f1e87f&scoped=true&"
import script from "./VideoEdit.vue?vue&type=script&lang=ts&"
export * from "./VideoEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1e87f",
  null
  
)

export default component.exports